$(document).ready(function(){
  function setKeyUpEvent() {
      
    $('.monogram__input-field').on('keypress keyup', function(e){
      var key = e.key;
      if (!isValid(key)) {
          e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
          e.preventDefault();
          return false;
      }else{
        e.target.value = e.target.value.toUpperCase();
        $('.monogram__input-field').attr('value', e.target.value)
      }
    });
  }

  function isValid(str) {
    return /^[a-zA-Z0-9]*$/.test(str) && /^[\x00-\x7F]*$/.test(str);

  }
  
function renderFunctions() {
  function closeMonogramPopup(action, wrap, pop_wrap){
      wrap.find('.monogram-error').remove();
      const monogram_input = wrap.find('.monogram__input-field');
      const monogram_button = wrap.find('.add_monogram')
      const form_id = wrap.attr('data-form-id')
      let form = $(`form#${form_id}`)
      if(!form || form.length == 0 ){
        form = $(`form#${form_id}-modal`)
      }
      const prod_id = monogram_input.attr('prod-id')
      const monogram_in_prod_form = $(`.monogram-input--prop-${prod_id}`)
      const monogram_link = wrap.find('.custom-monogram-link');
      const text = monogram_input.val();

      if(action === 'add'){
        if(text === ''){
          monogram_input.addClass('error');
          return false;
        }else if(!isValid(text)){
          monogram_input.addClass('error');
          $('<span class="monogram-error">Invalid</span>').insertAfter(monogram_button);
          return false;
        }else if(text.length > 3){
          monogram_input.addClass('error');
          $('<span class="monogram-error">Only 3 characters allowed</span>').insertAfter(monogram_button);
          return false;
        }else if(/[.]/g.test(text) === true) {
          monogram_input.addClass('error');
          $('<span class="monogram-error">Invalid</span>').insertAfter(monogram_button);
          return false;
        }else{
          // If the text is valid 

          // If monogram error message is showing, remove it
          if($('.monogram-error-atc-popup')){
            $('.monogram-error-atc-popup').fadeOut(function(){
              $('.monogram-error-atc-popup').remove()
            })
          }
          monogram_input.removeClass('error');
          pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').hide();
          monogram_input.attr('disabled','')


          // Update the hidden input field in the product form with the new value
          const value = monogram_input.val()
          monogram_in_prod_form.val(value) 
         if(value != "" ){
            if(monogram_in_prod_form && monogram_in_prod_form.length){
              $(monogram_in_prod_form).val(value)
              $(monogram_in_prod_form).attr('value', value)
            }else{
              const property = $(`<input type="hidden" aria-label="monogram-input" id="monogram-input--prop-${prod_id }" type="text" value="${value}" d-placeholder="" placeholder="" name="properties[Monogram]" data-maxlength="3" maxlength="3"  class="monogram-input--prop-${prod_id} monogram__input-field">`)
              
              $(form).prepend(property)
            }
          }

          
          // Hides add button
          const add_button = wrap.find('.add_monogram.button')
          $(add_button).css('display', 'none')

          // Shows delete button to page with click event 
          const delete_button = wrap.find('.delete_monogram')
          if(!$(delete_button).length){
            $('<button type="button" class="delete_monogram button">Remove</button>pop_wrap.find').insertAfter($(wrap).find('.custom-monogram-popup-form button'))  
            //Click handler on Delete monogram button
            $('.delete_monogram').on('click', function(){
              closeMonogramPopup('delete', $(wrap), $(pop_wrap));
            });
          }else{
            $(delete_button).css('display', 'block')
          }
          
        }
      }else if(action === 'delete'){
        // Re-enables the input field 
        monogram_input.removeAttr('disabled')
        // removes value from the hidden input in product form
        monogram_in_prod_form.val('')// old code to reset hidden input field 
        monogram_input.val(''); 
        monogram_input.removeClass('error');
        // Updated code to remove value from hidden input in product form
        let valueProp = $(".product-single__form .monogram__input-field")[0]// new code to reset hidden input value to ''
        $(valueProp).val('') // new code to reset hidden input value to ''
        // pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').hide();
        $('.delete_monogram').css('display', 'none')
        $('.add_monogram.button').css('display', 'block')
      }else{
        pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').hide();
        $('.lifetime-guarantee-badge').focus();
      }
    }
    
  setKeyUpEvent()
    $('.custom-monogram-link').on('click', function(e) {
      e.preventDefault();
      let pop_wrap = $(this).closest(".product-single__meta").find(".monogram-pop-wrap")
      pop_wrap.find('.custom-loader-overlay').show();
      $('.custom-loader').show();
      pop_wrap.find('.custom-monogram-popup').find('.monogram-close-button').focus();
      pop_wrap.find('.custom-monogram-popup').find('.custom-monogram-popup-close').attr('aria-label','close');
      pop_wrap.find('.custom-monogram-popup').find('.custom-monogram-popup-close').focus();
      if(pop_wrap.find('.custom-monogram-popup').attr('aria-modal') != 'true') {
        pop_wrap.find('.custom-monogram-popup').attr('role','dialog');
        pop_wrap.find('.custom-monogram-popup').attr('aria-modal','true');
        pop_wrap.find('.custom-monogram-popup').attr('aria-label','Personalize your Product name');
      }
      pop_wrap.find('.custom-monogram-popup-form input').removeAttr('disabled');
      $('.custom-loader-overlay').hide();
      $('.custom-loader').hide();
      pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').show();
          //return false;
    });
    function removeErrorMsg() {
      if($(".monogram-error-atc-popup")[0]){
        $('.monogram-error-atc-popup').fadeOut(function(){
          $('.monogram-error-atc-popup').remove()
        })
      }
    }
    $('.monogram__input-field').on('keypress keyup', function(e){
      var key = e.key;
      if (!isValid(key)) {
          e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
          e.preventDefault();
          return false;
      }else{
        e.target.value = e.target.value.toUpperCase();
        if(!$('.add_monogram').hasClass('is-active')){
          $('.add_monogram').addClass('is-active')
        }else{
          // If the last key action was deleting all values in the input field
          // Revert add button to inactive, hide any error message
          if($('.monogram__input-field').val() == ""){
            $('.add_monogram').removeClass('is-active')
            removeErrorMsg()
          }
        }
      }
    });
    
    function isValid(str) {
      return /^[a-zA-Z0-9]*$/.test(str) && /^[\x00-\x7F]*$/.test(str);
    }
    
    //Click handler on Add monogram button
    $('.add_monogram').on('click', function(){
      if($('.add_monogram').hasClass('is-active')){
        $('.add_monogram').removeClass('is-active')
      }
      removeErrorMsg()
      closeMonogramPopup('add', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
    });
    
    //Click handler on close icon and close button on popup
    $('.custom-monogram-popup-close').on('click', function(e) {
      closeMonogramPopup('', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
      e.preventDefault();
    });
    $('.monogram-close-button').on('click', function(e) {
      closeMonogramPopup('', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
      e.preventDefault();
    });
    $('.custom-monogram-popup-close').keydown(function(e) {
      if(e.which == 13) {
        closeMonogramPopup('', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
        e.preventDefault();
      }
    });
    $(document).on('focus', '#closeRefocus', function(){
        document.querySelector('.custom-monogram-popup-close').focus();
    });
    $(document).on('keydown blur', '.custom-monogram-popup.has-form', function(e){
      if (e.shiftKey && e.keyCode === 9) {
          return false;
      }
    });
    $(document).on('click', '.custom-monogram-overlay', function(e) {
      closeMonogramPopup();
      e.preventDefault();
    
      return false;
    });
    $(document).keyup(function(e) {
        if (e.keyCode === 27 && $('.custom-monogram-popup:visible').length > 0) {
          closeMonogramPopup();
        }
    });
    $(document).on('click', '.details-modal', function(){
      $('.custom-monogram-overlay, .custom-shipping-popup').fadeIn();
    })
    $(document).on('click', '.custom-shipping-popup-close', function(){
      $('.custom-monogram-overlay, .custom-shipping-popup').fadeOut();
    })
  }
  renderFunctions()
  $('.quick-product__btn').each(function(){
    $(this).on('click', function(){
      setTimeout(() => {
        renderFunctions()
      }, 1500);
    })
  })

  // Click event 
  let counter1 = 0
  const checkLoaded = setInterval(function(){
    let buttons = $('.quick-product__btn')
    if(buttons && buttons.length > 0 || counter1 >= 30){
      // Waits for quickview buttons to load on page before looping and setting click functions
      $(buttons).each(function(){
        $(this).on('click', function(e){

          setKeyUpEvent()
          let counter2 = 0
          const checkExist = setInterval(function(){
            let grid_prod = $(e.target).closest('.grid-product')
            let tabs;
            let grid_prod_id;
            if($(grid_prod).hasClass('ss__result')){
              // The Search Spring-built recommendations on PDP, cart, etc. 
              // Has a different structure for the grid product / quickshop modal (not nested within grid product parent element)
              grid_prod_id = $(e.target).closest('.grid-product').attr('data-product-id')
              tabs = $(`div#QuickShopModal-${grid_prod_id}`).find('.tablinks')
            }else{
              // Targets native YMAL /featured collection sections (HP, etc) where 
              // Quickshop modal is nested within the grid product element 
              tabs = $(e.target).closest('.grid-product').find('.tablinks')
            }

            if(tabs && tabs.length > 0 || counter2 >= 30){
              renderFunctions()
              clearInterval(checkExist)
            }
            counter2 ++
          }, 300);
        })
      })
      clearInterval(checkLoaded)
    }
    counter1 ++
  }, 300);


})
